import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'

import { Amazon } from './mixins/Amazon'
import InvalidFeedback from './components/InvalidFeedback'



import "./styles/app.css";

Vue.mixin(Amazon)
Vue.config.productionTip = false

// global components
Vue.component('invalid-feedback', InvalidFeedback);

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
